import { create } from "zustand";
import {
  getSchemaWithAddedObject,
  getDataWithAddedObject,
} from "../components/lib/dataTransformers";

import { prepareData, getSchemaAt } from "../components/renderers/utils";

const useStore = create((set, get) => ({
  // ! infoObjects === dataSchemas
  infoObjects: {}, // {info_obj: schema}
  unlabeledInfoObjects: {}, // {info_obj: schema}
  data: {}, // {info_obj: data}
  structureSchemas: {}, // {info_obj:structure_schema} TODO: integrate task structure
  isInitialized: false,
  promptIndicator: "...",

  // maybe do not use this
  labeledSchema: {},

  /**
   * {
   *  infoObject: 'travel_plan',
   *  path: '',
   *  viewType: "list" | "grid" | "canvas" | "stack" | "table" | "timeline",
   *  vid: xxx,
   *  options: {
   *    flattened: boolean,
   *  },
   * }
   */
  allViews: [],
  entitiesOI: [],
  _prompt: null,
  setPrompt: (prompt) => set({ _prompt: prompt }),
  setEntitiesOI: (entities) => set({ entitiesOI: entities }),

  setInfoObjects: (infoObjects) => set({ infoObjects: infoObjects }),
  setUnlabeledInfoObjects: (unlabeledInfoObjects) =>
    set({ unlabeledInfoObjects: unlabeledInfoObjects }),

  setLabelSchema: (labeledSchema) => set({ labeledSchema: labeledSchema }),

  changeCurrentFocus: (infoObject, idx) => {
    const allViews = get().allViews;
    const view = allViews.find((view) => view.infoObject === infoObject);
    view.currentFocus = idx;
    set({ allViews: [...allViews] });
  },
  setData: (data) => set({ data }),
  setInitialized: (isInitialized) => set({ isInitialized: isInitialized }),
  task: null,
  xray: false,
  baseStructure: ["list", "canvas", "grid", "stack", "table", "timeline"],
  // schema: null,
  pivotObject: null,
  collectionStructure: "list",
  rankedAttr: [],
  encoding: {},
  promptHistory: [], // [{anchor:.., prompt:..., timestamp:...}], anchor type: global, schema, ui
  loadingLegend: "",
  promptBoxPos: { x: 0, y: 0 },
  currentPromptAnchor: "global",
  setPromptIndicator: (promptIndicator) => set({ promptIndicator }),
  setCurrentPromptAnchor: (anchor) => set({ currentPromptAnchor: anchor }),
  ////
  addView: (view) => {
    const existingViews = get().allViews;
    let vid;

    if (!view.path.length) vid = `${view.infoObject}-ROOT`;
    else {
      const existingPathViews = existingViews.filter(
        (v) => v.path === view.path
      );

      const pathCount = existingPathViews.length;
      vid = `${view.infoObject}.${view.path}-${pathCount}`;
    }

    set((state) => ({
      allViews: [
        ...state.allViews,
        {
          ...view,
          vid,
          options: {
            flattened: false,
            rendered: true,
          },
        },
      ],
    }));
  },
  removeView: (vid) => {
    set((state) => ({
      allViews: state.allViews.filter((view) => view.vid !== vid),
    }));
  },
  updateView: (vid, newView) => {
    set((state) => ({
      allViews: state.allViews.map((view) =>
        view.vid === vid ? { ...view, ...newView } : view
      ),
    }));
  },
  setViews: (allViews) => {
    set({ allViews: allViews });
  },
  ////
  addNewView: (
    infoObject,
    structure,
    currentFocus,
    attributeviews,
    parent = null
  ) => {
    const allViews = get().allViews;
    allViews.push({
      infoObject: infoObject,
      structure: structure,
      currentFocus: currentFocus,
      attributeviews: attributeviews,
      parent: parent,
    });
    set({ allViews: [...allViews] });
  },
  deleteView: (view) => {
    const allViews = get().allViews;
    const idx = allViews.findIndex((v) => v.infoObject === view.infoObject);
    allViews.splice(idx, 1);
    set({ allViews: [...allViews] });
  },
  changeView: (infoObject, attr, structure, schema) => {
    const allViews = get().allViews;
    const idx = allViews.findIndex(
      (view) => view.infoObject === infoObject && view.attr === attr
    );
    allViews[idx].structure = structure;
    allViews[idx].schema = schema;
    set({ allViews: [...allViews] });
  },
  // updateView: (newView) => {
  //   const allViews = get().allViews;
  //   const idx = allViews.findIndex(
  //     (view) => view.infoObject === newView.infoObject
  //   );
  //   allViews[idx] = newView;
  //   set({ allViews: [...allViews] });
  // },
  colors: [
    "#9b99fa",
    "#f6c9f9",
    "#4cb8df",
    "#c7f2fd",
    "#3186C3",
    "#FFB82F",
    "#7AA358",
    "#4C94A1",
    "#AB4CE2",
  ],
  setTask: (task) => set({ task }),
  setPromptBoxPosition: (x, y) => set({ promptBoxPos: { x, y } }),
  getInfoObjects: () => {
    return get().infoObjects;
  },
  updateInfoObject: (info_obj, schema) => {
    const d = get().infoObjects;
    d[info_obj] = schema;
    set({ infoObjects: { ...d } });
  },
  updateUnlabeledInfoObject: (info_obj, schema) => {
    const d = get().unlabeledInfoObjects;
    d[info_obj] = schema;
    set({ unlabeledInfoObjects: { ...d } });
  },
  addPromptHistory: (prompt, src = "user", args) => {
    let anchor;
    if (src === "op_agent") {
      anchor = args.opid;
    } else {
      anchor = get().currentPromptAnchor;
    }
    const timestamp = new Date().getTime();
    const history = get().promptHistory;
    history.push({ anchor, prompt, timestamp, src });
    set({ promptHistory: [...history] });
  },
  getData: () => {
    return get().data;
  },
  getDataByInfoObject: (info_obj) => {
    return get().data[info_obj];
  },
  updateData: (info_obj, data) => {
    const d = get().data;
    d[info_obj] = data;
    set({ data: { ...d } });
  },
  ////
  // getSchemaAt: (infoObjectName, path) => {
  //   const schema = get().infoObjects[infoObjectName];
  //   const pathParts = path.split(".").filter((part) => !part.includes("["));

  //   return pathParts.reduce((acc, part) => {
  //     return acc && acc[part] ? acc[part] : undefined;
  //   }, schema);
  // },
  ////
  updateStructureSchema: (info_obj, structure_schema) => {
    const d = get().structureSchemas;
    d[info_obj] = structure_schema;
    set({ structureSchemas: d });
  },
  updateStructure: (info_obj, structure) => {
    const d = get().structureSchemas;
    d[info_obj]["structure"] = structure;
    set({ structureSchemas: d });
  },
  setPivotObject: (pivotObject) => set({ pivotObject }),
  setXray: (xray) => set({ xray }),
  setCollectionStructure: (collectionStructure) => set({ collectionStructure }),
  setRankedAttr: (rankedAttr) => set({ rankedAttr }),
  setLoadingLegend: (loadingLegend) => set({ loadingLegend }),
  changePivotObject: (newPivot, path) => {
    const infoObjects = get().infoObjects;
    if (Object.keys(infoObjects).includes(newPivot)) {
      set({ pivotObject: newPivot });
      return;
    } else {
      const __infoObjects = getSchemaWithAddedObject();
      const __newData = getDataWithAddedObject();
    }
  },
}));

export default useStore;

// {
//   infoObject: "UI pattern",
//   structure: "grid",
//   currentFocus: 0,
//   attributeviews: [
//     { attr: "references", structure: "list", pinned:false},
//     { attr: "references", structure: "canvas" },
//     // { attr: "2", structure: "list" },
//   ],
// },
// {
//   infoObject: "UI pattern",
//   currentFocus: 0,
//   structure: "table",
//   attributeviews: [],
//   currentFocus: null,
// },

export const useSchema = (infoObjectName, path, forcePointed = false) => {
  const schemas = useStore((state) => state.infoObjects);
  // const getSchemaAt = useStore((state) => state.getSchemaAt);
  const schema = getSchemaAt(schemas, infoObjectName, path, forcePointed);

  return schema;
};

export const useData = () => {
  return useStore((state) => state.data);
};
